import { UserPermissions } from 'global-constants';
import useGetUserPermissions from 'hooks/useGetUserPermissions';
import React from 'react';
import { useNavigate } from 'react-router-dom';

export const useJamfBetaPermissionCheck = () => {
  const navigate = useNavigate();
  const userPermissions = useGetUserPermissions();
  
  React.useEffect(() => {
    const hasPermissionsLoaded = !userPermissions.includes(
      UserPermissions.NOT__LOADED
    );
    
    const hasIntegrationsBetaPermission = userPermissions.includes(
      UserPermissions.INTEGRATIONS_BETA
    );
    
    if (hasPermissionsLoaded && !hasIntegrationsBetaPermission) {
      navigate('/integrations');
    }
  }, [userPermissions, navigate]);
};
